import type { Locale } from '@seaa/shared'
import { formatCurrency } from './currency'

export { currencySymbol } from './currency'

export interface DemoMarket {
  currency: 'EUR' | 'SAR'
  venueSlug: string
  sampleDepositCents: number
}

const europeanDemoSlug = import.meta.env.VITE_DEMO_VENUE_SLUG || 'riverside-racket-club'
const arabicDemoSlug = import.meta.env.VITE_ARABIC_DEMO_VENUE_SLUG || 'riyadh-sports-hub'

export function demoMarket(locale: Locale): DemoMarket {
  // Launch languages share one Saudi market; language is not a currency choice.
  if (locale === 'ar' || locale === 'en') {
    return {
      currency: 'SAR',
      venueSlug: arabicDemoSlug,
      sampleDepositCents: 12_000,
    }
  }

  return {
    currency: 'EUR',
    venueSlug: europeanDemoSlug,
    sampleDepositCents: 1_600,
  }
}

export function formatMarketMoney(cents: number, currency: string, intlLocale: string) {
  return formatCurrency(cents, currency, intlLocale, {
    maximumFractionDigits: 0,
  })
}
